import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from '../pages/Dashboard/Dashboard';

import Page403 from '../pages/Shared/Page403';
import Page404 from '../pages/Shared/Page404';
import Page500 from '../pages/Shared/Page500';
import Page503 from '../pages/Shared/Page503';
import Maintenance from '../pages/Shared/Maintenance';

import SecuredShell from '../shared/ui/SecuredShell';
import Analytical from '../pages/Dashboard/Analytical';
import ActiveSubscriptions from '../pages/Products/ActiveSubscriptions';
import LastInvoices from '../pages/Invoices/LastInvoices';
import ProductsOverview from '../pages/Products/ProductsOverview';
import VpsOverview from '../pages/Vps/VpsOverview';
import VpsDetails from '../pages/Vps/VpsDetails';
import InvoiceDetails from '../pages/Invoices/InvoiceDetails';
import EditAccount from '../pages/Account/EditAccount';
import CheckDomain from '../pages/Domain/CheckDomain';
import QuoteOverview from '../pages/Quotes/QuoteOverview';
import QuoteDetails from '../pages/Quotes/QuoteDetails';
import DomainOverview from '../pages/Domain/DomainOverview';
import DomainDetails from '../pages/Domain/DomainDetails';
import Logout from '../pages/Auth/Logout';
import PageNotFound from '../pages/Screens/PageNotFound';
import WordpressOverview from '../pages/Vps/WordpressOverview';
import WordpressDetails from '../pages/Vps/WordpressDetails';
import LinkedHelperVpsOverview from '../pages/Vps/LinkedHelperVpsOverview';
import LinkedHelperVpsDetails from '../pages/Vps/LinkedHelperVpsDetails';
import VpsDashboard from '../pages/Vps/VpsDashboard';

export default function Authorized(): JSX.Element {
  return (
    <Routes>
      <Route
        path="page403"
        element={
          <SecuredShell title="Access denied">
            <Page403 />
          </SecuredShell>
        }
      />
      <Route
        path="page404"
        element={
          <SecuredShell title="Not found">
            <Page404 />
          </SecuredShell>
        }
      />
      <Route
        path="page500"
        element={
          <SecuredShell title="Server error">
            <Page500 />
          </SecuredShell>
        }
      />
      <Route
        path="page503"
        element={
          <SecuredShell title="Service unavailable">
            <Page503 />
          </SecuredShell>
        }
      />
      <Route
        path="maintenance"
        element={
          <SecuredShell title="Maintenance">
            <Maintenance />
          </SecuredShell>
        }
      />

      <Route path="logout" element={<Logout></Logout>} />

      <Route
        path="dashboard/analytical"
        element={
          <SecuredShell title="Analytical">
            <Analytical />
          </SecuredShell>
        }
      />
      <Route
        path="dashboard"
        element={
          <SecuredShell title="Dashboard">
            <Dashboard />
          </SecuredShell>
        }
      />
      <Route
        path="products/active"
        element={
          <SecuredShell title="Active subscriptions">
            <ActiveSubscriptions />
          </SecuredShell>
        }
      />
      <Route
        path="products/overview"
        element={
          <SecuredShell title="Products">
            <ProductsOverview />
          </SecuredShell>
        }
      />

      <Route
        path="finance/invoices/recent"
        element={
          <SecuredShell title="Invoices">
            <LastInvoices />
          </SecuredShell>
        }
      />
      <Route
        path="finance/invoices/details/:uuid"
        element={
          <SecuredShell
            title="Invoice"
            parent={{ label: 'Invoices', to: '/finance/invoices/recent' }}
          >
            <InvoiceDetails />
          </SecuredShell>
        }
      />
      {/* BHP-1064: the detail page used to be id-less and read its invoice from
          a selection store. Keep the old path alive for existing bookmarks —
          without a uuid there is nothing to show. */}
      <Route
        path="finance/invoices/details"
        element={<Navigate to="/finance/invoices/recent" replace />}
      />
      <Route
        path="finance/invoices"
        element={<Navigate to="/finance/invoices/recent" replace />}
      />
      <Route
        path="finance/quotes/recent"
        element={
          <SecuredShell title="Quotes">
            <QuoteOverview />
          </SecuredShell>
        }
      />
      <Route
        path="finance/quotes/details"
        element={
          <SecuredShell title="Quote">
            <QuoteDetails />
          </SecuredShell>
        }
      />
      <Route
        path="finance/quotes"
        element={<Navigate to="/finance/quotes/recent" replace />}
      />

      <Route
        path="vps/wordpress/overview"
        element={
          <SecuredShell title="Managed WordPress">
            <WordpressOverview />
          </SecuredShell>
        }
      />
      <Route
        path="vps/wordpress/:uuid"
        element={
          <SecuredShell title="WordPress instance">
            <WordpressDetails />
          </SecuredShell>
        }
      />

      <Route
        path="vps/generic/overview"
        element={
          <SecuredShell title="VPS servers">
            <VpsOverview />
          </SecuredShell>
        }
      />
      <Route
        path="vps/generic/:uuid"
        element={
          <SecuredShell title="VPS server">
            <VpsDetails />
          </SecuredShell>
        }
      />

      <Route
        path="vps/linked-helper/overview"
        element={
          <SecuredShell title="Linked Helper VPS">
            <LinkedHelperVpsOverview />
          </SecuredShell>
        }
      />
      <Route
        path="vps/linked-helper/:uuid"
        element={
          <SecuredShell title="Linked Helper VPS">
            <LinkedHelperVpsDetails />
          </SecuredShell>
        }
      />

      <Route
        path="vps"
        element={
          <SecuredShell title="VPS">
            <VpsDashboard />
          </SecuredShell>
        }
      />

      <Route
        path="account/change"
        element={
          <SecuredShell title="Account">
            <EditAccount />
          </SecuredShell>
        }
      />

      <Route
        path="domain/check"
        element={
          <SecuredShell
            title="Check domain"
            parent={{ label: 'Domains', to: '/domain/dashboard' }}
          >
            <CheckDomain />
          </SecuredShell>
        }
      />
      <Route
        path="domain/dashboard"
        element={
          <SecuredShell title="Domains">
            <DomainOverview />
          </SecuredShell>
        }
      />
      <Route
        path="domain/details/:uuid"
        element={
          <SecuredShell
            title="Domain"
            parent={{ label: 'Domains', to: '/domain/dashboard' }}
          >
            <DomainDetails />
          </SecuredShell>
        }
      />
      {/* BHP-1099: the detail page used to be id-less. Keep the old path alive
          for existing bookmarks — without a uuid there is nothing to show. */}
      <Route
        path="domain/details"
        element={<Navigate to="/domain/dashboard" replace />}
      />
      <Route
        path="not-found"
        element={
          <SecuredShell title="Not found">
            <PageNotFound />
          </SecuredShell>
        }
      />

      {/* BHP-1042: if an authenticated session lands back on the OIDC
            redirect target, send it to the app instead of the 404. */}
      <Route path="callback" element={<Navigate to="/dashboard" replace />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}
